import { Helmet } from 'react-helmet';
import React from 'react';

import useActivePage from '../../shared/custom-hooks/active-page';

const MetaData = ({ children }) => {
  const activePage = useActivePage();

  return (
    <>
      <Helmet>
        <title>{activePage.title}</title>
      </Helmet>

      {children}
    </>
  );
};

export default MetaData;